import {deserialize, serialize, serializeAs} from 'libs/cerialize';

export class MsAccessColumnDto {
	@deserialize
	Name: string;

    @deserialize
	Type: string;
}